<div class="email-setup">
  <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" *ngIf="!showSteps" class="email-form">
    <div class="form-header">
      <h2 class="title">{{ dialogTitle | transloco}}</h2>
      <p class="subtitle">
        {{ 'confirm_email.description' | transloco }}
      </p>
    </div>

    <div class="form-content">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'confirm_email.email_label' | transloco }}</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" />
        <mat-error *ngIf="email?.hasError('required')">{{ 'confirm_email.email_required' | transloco }}</mat-error>
        <mat-error *ngIf="email?.hasError('email')">{{ 'confirm_email.email_invalid' | transloco }}</mat-error>
      </mat-form-field>

      <p class="support-text">
        {{ 'confirm_email.support_text' | transloco }} <a class="phone-number" href="tel:+21650889833">+216 50 889 833</a>.
      </p>
    </div>

    <div class="form-footer">
      <button class="primary-pill" mat-raised-button type="submit" [disabled]="emailForm.invalid || loading">
        <span>{{
            loading
              ? ('confirm_email.sending_short' | transloco)
              : isEmailUnchanged
                ? ('confirm_email.continue' | transloco)
                : ('confirm_email.send' | transloco)
          }}</span>
      </button>
    </div>
  </form>

  <div *ngIf="showSteps" class="steps">
    <div class="steps-header">
      <h2 class="title">{{ 'confirm_email.sent_title' | transloco }}</h2>
    </div>

    <div class="steps-content">
      <div class="image-container">
        <img src="assets/gifs/email_verification.gif" alt="Email confirmation" class="conf-image" />
      </div>

      <p class="email-sent">{{ 'confirm_email.email_sent_to' | transloco }}
        <strong>{{ submittedEmail || emailForm.value?.email }}</strong></p>

      <ol class="instructions">
        <li data-number="1">
          <strong>{{ 'confirm_email.open_email' | transloco }}</strong>
          <span>{{ 'confirm_email.check_spam' | transloco }}</span>
        </li>
        <li data-number="2">
          <strong>{{ 'confirm_email.click_confirmation_button' | transloco }}</strong>
          <span>{{ 'confirm_email.confirm_button_in_email' | transloco }}</span>
        </li>
      </ol>

      <p class="support-text mt-40">
        {{ 'confirm_email.support_text' | transloco }} <a class="phone-number" href="tel:+21650889833">+216 50 889 833</a>.
      </p>

      <button class="resend-button" type="button" (click)="resendConfirmation()" [disabled]="sending">
        <span *ngIf="!sending">{{ 'confirm_email.resend_email' | transloco }}</span>
        <span *ngIf="sending">{{ 'confirm_email.sending' | transloco }}</span>
      </button>
    </div>

    <div class="steps-footer">
      <button mat-stroked-button type="button" (click)="editEmail()" class="">
        {{ 'confirm_email.edit_email' | transloco }}
      </button>
      <button class="primary-pill" mat-raised-button type="button" (click)="onClose()">
        {{ 'confirm_email.understood' | transloco }}
      </button>
    </div>
  </div>
</div>
